import React from "react";
import "./MessageFromPresidentSection.scss";
import ContentSection from "../components/ContentSection";
import TwoColumnLayout from "../components/TwoColumnLayout";
import PRESIDENT_IMAGE from "../assets/images/jason-whyte.png";
// ...existing imports

const MessageFromPresidentSection: React.FC = () => {
  const leftContent = (
    <>
      <p>
        Most Americans know someone who has been involved with the criminal
        justice system. They are our friends, family members, and in some cases,
        ourselves. These are individuals with the same aptitude, drive, and
        talents as those fortunate enough to have avoided a criminal record.
      </p>
      <p>
        Yet, justice-involved job seekers have long been overlooked in our labor
        force. Their opportunities are too often curtailed by licensing
        restrictions, employer and public stigma, limited access to skills
        training, and a host of other collateral consequences that shadow them
        long after incarceration.
      </p>
      <p>
        Across the country, there are dedicated individuals working to change
        that narrative. These are passionate, committed professionals who have
        devoted their careers to creating pathways for justice- involved job
        seekers toward family- sustaining employment. They work to connect job
        seekers with not only good jobs, but also the stability, dignity, and
        sense of belonging that meaningful work can bring. We are proud to
        present this inaugural State of the Reentry Workforce report for those
        professionals and all members of the reentry workforce field. This
        report provides a snapshot for the state of our field, highlighting
        emerging trends, sharing proven best practices, and identifying the
        opportunities that lie ahead. It reflects the power of a community
        united: experts from across systems working together to advance fair
        hiring practices and expand opportunity.
      </p>
      <p>
        Together, we can continue building a future where every person returning
        from incarceration has a fair chance to contribute their skills, support
        their families, and strengthen our communities. We look forward to
        continuing that pursuit with you all.
      </p>
      <p>
        Sincerely,
        <br />
        Jason Whyte
      </p>
    </>
  );

  const rightContent = (
    <div className="president-image-container">
      <div className="president-image">
        <img src={PRESIDENT_IMAGE} alt="" />
      </div>
    </div>
  );

  return (
    <ContentSection
      id="message-from-the-president"
      title="Message from the President"
      description="Dear colleagues,"
    >
      <TwoColumnLayout leftContent={leftContent} rightContent={rightContent} />
    </ContentSection>
  );
};

export default MessageFromPresidentSection;
